<tt-page *ngIf="!!page">
    <ng-container *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="editUserGroupSetting"></ng-container>
        </tt-card>
    </ng-container>

    <ng-container *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-card ttHeading="h_usergroup_setting_edit">
            <ng-container *ngTemplateOutlet="editUserGroupSetting"></ng-container>
        </tt-card>
    </ng-container>
</tt-page>

<ng-template #editUserGroupSetting>
    <ng-container *ngIf="!!page">
        <tt-input ttLabel="usergroup_name" [ttModel]="page.usergroup_name" ttReadonly></tt-input>
        <tt-input ttLabel="setting_name" [ttModel]="page.setting_name" ttReadonly></tt-input>
        <tt-checkbox ttLabel="ok" [(ttModel)]="page.setting_value"></tt-checkbox>
        <tt-button-save ttText="save" ttTextAlign="center" [ttLoading]="saving" (ttClick)="save()"></tt-button-save>
    </ng-container>
</ng-template>
